export default "__VITE_ASSET__BB08RUu1__"